import React from 'react'

function escapeHtml(str: string) {
  return str
    .replaceAll(/&/g, '&amp;')
    .replaceAll(/</g, '&lt;')
    .replaceAll(/>/g, '&gt;')
}

function simpleMarkdownToHtml(src: string) {
  // Escape first
  let s = escapeHtml(src)
  // Bold: **text**
  s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
  // Italic: *text*
  s = s.replace(/\*(.+?)\*/g, '<em>$1</em>')
  // Inline code: `code`
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>')
  // Paragraphs: split by double newline
  const parts = s.split(/\n\s*\n/)
  const wrapped = parts.map(p => `<p>${p.replace(/\n/g, '<br/>')}</p>`).join('')
  return wrapped
}

export default function Markdown({ children }: { children?: React.ReactNode }) {
  const text = typeof children === 'string' ? children : (Array.isArray(children) ? children.join('') : '')
  const html = simpleMarkdownToHtml(text ?? '')
  return <div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: html }} />
}

